import { useQueryClient } from '@tanstack/react-query';

import { plantQueryKeys } from './plantQueryKeys';

const usePlantQueryInvalidation = () => {
  const queryClient = useQueryClient();

  return {
    invalidatePlantList: () => queryClient.invalidateQueries({ queryKey: plantQueryKeys.all }),
    invalidatePlantDetail: (plantId: string) =>
      queryClient.invalidateQueries({ queryKey: plantQueryKeys.detail(plantId) }),
  };
};

export default usePlantQueryInvalidation;
